export default __webpack_public_path__ + "static/media/attendance-red-cross.cc39a432.svg";